import { render, staticRenderFns } from "./KnownActionDetail.vue?vue&type=template&id=bf59f8a4&"
import script from "./KnownActionDetail.vue?vue&type=script&lang=js&"
export * from "./KnownActionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports